import React, { useState }  from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import './Navbar.scss';
import DarkMode from '../DarkMode/DarkMode';


const Navbar = () => {
  const [toggle, setToggle] = useState(false); 

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={ images.logo } alt="logo" className='logo-theme'/>
      </div>
      <ul className='app__navbar-links'>
        { ['home', 'about', 'work', 'skills', 'contact'].map((item) => (
          <li className='app__flex p-text' key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
        <DarkMode />      
      </ul>
      
      
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)}/>
        {
          toggle && (
            
            <motion.div
            whileInView={{ x: [-80, 0] }}
            transition={{ duration: 0.2 }}
              className='mini-navbar'
            >
              <HiX className='HiX' onClick={() => setToggle(false)}/>
              
              <ul>
                <img src={ images.logo } alt="logo" id='logo-theme'/>
                <p className='p-text'> Bring your imagination to life </p>
                { ['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                  <li key={item}>
                    <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                  </li>
                ))}  
              </ul>   
                                    
            </motion.div>
          )
        }
      </div>
    </nav>
  );
}

export default Navbar;